import { useContext, useEffect, useState } from "react";
import AdminCommonComponent from "../../components/AdminCommonComponent";
import styles from "./adminsettings.module.css";
import { useSelector } from "react-redux";
import ResetPassword from "../../../../Components/ForgetPassword/ResetPassword";
import LoaderContext from "../../../../Components/loader";
import { BasicSettings } from "../../../../App/api/setting";

const AdminSettings = () => {

  const store = useSelector((state) => state.store)
  const { handleLoading } = useContext(LoaderContext)
  const [isResetPwdModal, setIsResetPwdModal] = useState(false);
  const { app_name, email, phone_number, city, country } = store?.currentUser?.data?.user
  const [editSiteData,setEditSiteData]=useState(null)  

  const countryName =
    typeof country === "object" ? country?.name || "" : country || "";
  const cityName = typeof city === "object" ? city?.name || "" : city || "";

  const getSiteSettings = async () => {
    try {
      handleLoading(true)
      const res = await BasicSettings.getSiteSettings()
      setEditSiteData(res?.data?.data[0])
      handleLoading(false)
    } catch (error) {
      handleLoading(false)
    }
  }

  useEffect(() => {
    getSiteSettings()
  }, [])


  const data = [
    {
      label: "App Name",
      value: editSiteData?.appName || "eDelivery",
      dropDown: false,
      options: [],
      title: "",
      toggle: false,
    },
    {
      label: "Email",
      value: email || "",
      dropDown: false,
      options: [],
      title: "",
      toggle: false,
    },
    {
      label: "Phone",
      value: editSiteData?.contactPhone || "",
      dropDown: false,
      options: [],
      title: "",
      toggle: false,
    },
    {
      label: "Contact Email ",
      value: email || "",
      dropDown: false,
      options: [],
      title: "Set Admin's contact Email",
      toggle: false,
    },
    // {
    //   label: "Contact phone ",
    //   value: phone_number || "",
    //   dropDown: false,
    //   options: [],
    //   title: "Set Admin's contact phone number",
    //   toggle: false,
    // },
    {
      label: "Country",
      value: countryName,
      dropDown: false,
      options: [],
      title: "",
      toggle: false,
    },
    {
      label: "City",
      value: cityName,
      dropDown: false,
      options: [],
      title: "",
      toggle: false,
    },
    // {
    //   label: "Latitude",
    //   value: "23.0225",
    //   dropDown: false,
    //   options: [],
    //   title: "default latitude for map in panel",
    //   toggle: false,
    // },
    // {
    //   label: "Longitude ",
    //   value: "23.0225",
    //   dropDown: false,
    //   options: [],
    //   title: "default Longitude  for map in panel",
    //   toggle: false,
    // },
    // {
    //   label: "Admin Panel Timezone ",
    //   value: "Asia/kolkata",
    //   dropDown: false,
    //   options: [],
    //   title: "set timezone for admin panel",
    //   toggle: false,
    // },
    // {
    //   label: "Delivery Man Time Out  ",
    //   value: "60 sec",
    //   dropDown: false,
    //   options: [],
    //   title: "set timeout for delivery partner request",
    //   toggle: false,
    // },
    // {
    //   label: "Default Search Radius ",
    //   value: "20000 km",
    //   dropDown: false,
    //   options: [],
    //   title: "defualt search radius for looking partner",
    //   toggle: false,
    // },
    // {
    //   label: "View Activity Log Priority",
    //   value: "",
    //   dropDown: false,
    //   options: [],
    //   title: "",
    //   toggle: false,
    // },
    // {
    //   label: "Phone number length",
    //   value: "7 - 15 ",
    //   dropDown: false,
    //   options: [],
    //   title: "Min to Max phone number length",
    //   toggle: false,
    // },
  ];

  // const data2 = [
  //   {
  //     label: "Send SMS ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title: "For send SMS",
  //     toggle: true,
  //   },
  //   {
  //     label: "Send mail ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title: "Send For mail",
  //     toggle: true,
  //   },
  //   {
  //     label: "Push notification ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title: "For all push notification",
  //     toggle: true,
  //   },   
  //   {
  //     label: "Complete delivery confirmation code ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title:
  //       "when partner complete order,then will be asked for complete confirmation code",
  //     toggle: true,
  //   },  
  //   {
  //     label: "Allow pickup order verification ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title: "order verification for pickup order",
  //     toggle: true,
  //   },
  //   {
  //     label: "Tip ",
  //     value: "",
  //     dropDown: true,
  //     options: [
  //       {
  //         label: "PERCENTAGE",
  //         value: "PERCENTAGE",
  //       },
  //       {
  //         label: "ABSOLUTE",
  //         value: "ABSOLUTE",
  //       },
  //     ],
  //     title: "user can tip driver",
  //     toggle: false,
  //     dropDownValue: "PERCENTAGE",
  //   },
  //   {
  //     label: "Tip type ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title: "user can tip driver",
  //     toggle: true,
  //   },
  //   {
  //     label: "Use Google Captcha? ",
  //     value: "",
  //     dropDown: false,
  //     options: [],
  //     title: "Use Google Captcha?",
  //     toggle: true,
  //   },    
  // ];

  return (
    <>
      <div className={styles.container}>
        <AdminCommonComponent header={"Admin Settings"} data={data} buttonName={"Reset Password"} handleButton={() => setIsResetPwdModal(true)} />
        {isResetPwdModal && <ResetPassword handleResetClose={() => setIsResetPwdModal(false)} email={email} />}
        {/* <AdminCommonComponent header={"Admin Settings"} data={data} /> */}
        {/* <AdminCommonComponent header={"other Settings"} data={data2} /> */}
      </div>
    </>
  );
};

export default AdminSettings;
